(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-certifications"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.certification-overlay').hide();
    $('.certification-button').click(function (e) {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("open");
	    if ($(this).text() == "Learn More +") { 
	          $(this).text("Close -"); 
	      } else { 
	          $(this).text("Learn More +"); 
	      }; 
		
	   
		
		e.preventDefault();
      
    });
    $('.certification-overlay').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-faq"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
$(document).ready(function () {

    $('.mob-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.mobile-child').slideUp(200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
$(document).ready(function() {

	//Set the initial state: highlight the first button...
	$('.faq-nav').find('li:eq(0)').addClass('active');

	//and hide all tab content except the first one
	$('.faq-content').find('> div:eq(0)').nextAll().hide();

	//actions that apply on click of any of the buttons
	$('.faq-nav li').click( function(event) {

		//turn off the link so it doesn't try to jump down the page
		event.preventDefault();

		//un-highlight the buttons
		$('.faq-nav li').removeClass();

		//hide all the slides
		$('.faq-content > div').hide();

		//highlight the current button
		$(this).addClass('active');

		//get the index of the current button...
		var index = $('.faq-nav li').index(this);

		//and use that index to show the corresponding slide
		$('.faq-content > div:eq('+index+')').show();

	});

});


  } catch(e) { console.error(e); }
})();
})();
